import React, { useState } from 'react'
import { InputGroup, Alert, Form, Button } from 'react-bootstrap'
import { serRePassword } from '../../axios';
import { useSelector } from 'react-redux';
import langList from '../../utils/languagelist.json'

export default function Repwd() {
  const [msgError, setMsgError] = useState('');
  const [inputValues, setInputValues] = useState(Array(3).fill(''));
  const [showPassword0, setShowPassword0] = useState('password');
  const [showPassword1, setShowPassword1] = useState('password');
  const [showPassword2, setShowPassword2] = useState('password');

  const {usern}=useSelector((state)=>state.logininfo);
  const {lg}=useSelector((state)=>state.language);

  const password0Click=()=>{
    if(showPassword0==='password'){
      setShowPassword0('text');
    }else{
      setShowPassword0('password');
    }
  };

  const password1Click=()=>{
    if(showPassword1==='password'){
      setShowPassword1('text');
    }else{
      setShowPassword1('password');
    }
  };

  const password2Click=()=>{
    if(showPassword2==='password'){
      setShowPassword2('text');
    }else{
      setShowPassword2('password');
    }
  };

  const handleInputChange = (index,value) => { 
    const newInputValues=[...inputValues];
    newInputValues[index]=value;
    setInputValues(newInputValues);
  }

  const handlePasswordChange = (index,value) => {
    handleInputChange(index,value);
    if (!(value===inputValues[1].substring(0,value.length))) {
      setMsgError(`0${langList.repwd1[lg]}`);
    }else{
      setMsgError('');
    }
  };

  const handleClick = () => {
    if(msgError){
      return;
    };
    if(!(inputValues[1]===inputValues[2])){
      setMsgError(`0${langList.repwd1[lg]}`);
      return;
    };
    const regex1=/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?!.*\s).{8,20}$/;
    const regex2=/^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{};:,<.>])(?!.*\s).{8,20}$/;
    const regex3=/^(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{};:,<.>])(?!.*\s).{8,20}$/;
    const regex4=/^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()\-_=+{};:,<.>])(?!.*\s).{8,20}$/;
    if(!regex1.test(inputValues[0]) && !regex2.test(inputValues[0]) && 
       !regex3.test(inputValues[0]) && !regex4.test(inputValues[0])){
      setMsgError(`0${langList.repwd2[lg]}`);
      return;
    };
    if(!regex1.test(inputValues[1]) && !regex2.test(inputValues[1]) && 
       !regex3.test(inputValues[1]) && !regex4.test(inputValues[1])){
      setMsgError(`0${langList.repwd3[lg]}`);
      return;
    };
    if(inputValues[0]===inputValues[1]){
      setMsgError(`0${langList.repwd4[lg]}`);
      return;
    };
    serRePassword({name:usern,pwd:inputValues})
    .then(res =>{
      const code=res.code;
      if(code===21){
        setMsgError(`0${langList.repwd5[lg]}`);
        return;
      };
      if(code===20){
        setMsgError(`1${langList.repwd6[lg]}`);
        inputValues[0]='';
        inputValues[1]='';
        inputValues[2]='';
        return;
      };
    })
    .catch(err =>{
      setMsgError('0'+err.message);
    });
  }

  if(msgError){
    setTimeout(() => {
      setMsgError('');
    }, 5000);
  };

  return (
    <div>
      <div className='mb-1'>{langList.repwd7[lg]}</div>
      <InputGroup className="mb-4">
        <InputGroup.Text>
          <img src='./pic/lock.svg' alt=''/>
        </InputGroup.Text>
        <Form.Control
          id='pwd0'
          type={showPassword0}
          value={inputValues[0]}
          onChange={e=>{handleInputChange(0,e.target.value)}}
        />
        <InputGroup.Text style={{cursor: 'pointer'}} onClick={password0Click}>
          <img src={showPassword0==='password'?'./pic/eye.svg':'./pic/eye-slash.svg'} alt=''/>
        </InputGroup.Text>
      </InputGroup>
      <div className='mb-1'>{langList.repwd9[lg]}</div>
      <InputGroup className="mb-2">
        <InputGroup.Text>
          <img src='./pic/lock.svg' alt=''/>
        </InputGroup.Text>
        <Form.Control
          id='pwd1'
          type={showPassword1}
          value={inputValues[1]}
          onChange={e=>{handleInputChange(1,e.target.value)}}
        />
        <InputGroup.Text style={{cursor: 'pointer'}} onClick={password1Click}>
          <img src={showPassword1==='password'?'./pic/eye.svg':'./pic/eye-slash.svg'} alt=''/>
        </InputGroup.Text>
      </InputGroup>
      <div className='mb-1'>{langList.repwd11[lg]}</div>
      <InputGroup className="mb-1">
        <InputGroup.Text>
          <img src='./pic/lock.svg' alt=''/>
        </InputGroup.Text>
        <Form.Control 
          id='pwd2'
          type={showPassword2}
          value={inputValues[2]}
          onChange={e=>{handlePasswordChange(2,e.target.value)}}
        />
        <InputGroup.Text style={{cursor: 'pointer'}} onClick={password2Click}>
          <img src={showPassword2==='password'?'./pic/eye.svg':'./pic/eye-slash.svg'} alt=''/>
        </InputGroup.Text>
      </InputGroup>
      <div className='pb-5 position-relative'>
        <Alert 
          show={msgError===''?false:true} 
          variant={msgError.substring(0,1)==='0'?'danger':'success'} 
          className='py-1 text-center text-danger position-absolute w-100'
        >
          {msgError.substring(1)}
        </Alert>
      </div>
      <div className='text-center'>
        <Button
          variant="primary"
          className='w-25'
          onClick={handleClick}
        >{langList.public6[lg]}</Button>
      </div>
    </div>
  )
};

